import { render, staticRenderFns } from "./deleteAssetInventory.vue?vue&type=template&id=358535d9"
import script from "./deleteAssetInventory.vue?vue&type=script&lang=js"
export * from "./deleteAssetInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports